import React from 'react';
import Panel from '../components/Panel';

export function showPanelLoading() {

  return (<Panel>

  </Panel>);
}

export function showPageNotFound() {

  return (<Panel title="Page Not Found!">

  </Panel>);
}

export default {
  showPanelLoading,
  showPageNotFound
}


// WEBPACK FOOTER //
// ./src/lib/helpers.js